// export const SITE_NAME = "GeeCom India";
// export const FRONTEND_BASE_URL_WITHOUT_SSL = "rmstfe.geecomindia.in";
// export const FRONTEND_BASE_URL = "https://" + FRONTEND_BASE_URL_WITHOUT_SSL;
// export const API_BASE_URL_WITHOUT_SSL = "rmstest.geecomindia.in";
// export const API_BASE_URL = "https://" + API_BASE_URL_WITHOUT_SSL;
// export const FILE_BASE_URL = API_BASE_URL + "/uploads/";
// export const API_BASE = API_BASE_URL + "/api";

export const SITE_NAME = "GeeCom India";
export const FRONTEND_BASE_URL_WITHOUT_SSL = "rmsl.geecomindia.in";
export const FRONTEND_BASE_URL = "https://" + FRONTEND_BASE_URL_WITHOUT_SSL;
export const API_BASE_URL_WITHOUT_SSL = "rmsl.geecomindia.in";
export const API_BASE_URL = "https://" + API_BASE_URL_WITHOUT_SSL;
export const FILE_BASE_URL = API_BASE_URL + "/uploads/";
export const API_BASE = API_BASE_URL + "/api";
